import React from 'react';
import { Box, Button } from "@mui/material";

const Projects = () => {

    window.addEventListener('scroll', reveal);
    function reveal() {
      const reveals = document.querySelectorAll('.reveal');
      for (let i = 0; i < reveals.length; i++) {
        const windowHeight = window.innerHeight;
        const elementTop = reveals[i].getBoundingClientRect().top;
        const elementVisible = 150;
  
        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add('active');
        }
      }
      return reveals;
    }
    React.useEffect(() => {
      const reveals = reveal();
      reveals[0].classList.add('active');
    });
  
    return (
      <div
        id="projects-section-id"
        style={{
        //   backgroundImage: "url(images/AboutUsBackground.jpeg)",
        //   backgroundSize: "cover",
          // width: "100vw",
          minHeight: "100vh",
          backgroundColor: "#161618",
        }}
      >
        <div className="projects-main-container">
            <div className="projects-content-left reveal reveal1">
                <div className="title"> Our Projects</div>
                <div className="line"></div>
                <br></br>
                <br></br>
                <br></br>
                <br></br>

                <div className="genres">
                    <div className="selected-genre">
                        Survival Horror 
                    </div>
                    <div className="selected-genre">
                        Action
                    </div>
                    <div className="selected-genre ">
                        Multiplayer
                    </div>
                </div>
                <br></br>
                <div className="sub-title"> Sorry, Wrong Door</div>
                <div className="darker-text">It's an action-packed and laughter-inducing rollercoaster, A multiplayer horror game that'll leave you on the edge of your seat! Get ready to face the almighty demon, conquer spine-chilling mini-bosses, experience hilarious surprises, and engage in heart-pounding battles, all while a comical twist awaits around every corner!</div>
                <div>
                    <Button
                    variant="contained"
                    href="https://store.steampowered.com/app/2133810/Sorry_wrong_door/"
                    target="_blank"
                    sx={{
                        backgroundColor: "#bf1916",
                        // marginBottom: 15,
                        width: 220,
                        height: 50,
                        maxWidth: "100%",
                        fontFamily: "sans-serif,Georgia,Time",
                        // textTransform:"none",
                        margin: "20px 0px",
                        "&.MuiButtonBase-root:hover": {
                        bgcolor: "#900c0a",
                        // color: "black",
                        },
                    }}
                    >
                    Discover More
                    </Button>
                </div>
            </div>
            <div className="projects-content-right reveal reveal3">
                <div className="img-container">
                <img src="images/SWD_No_Title_Final.jpeg"/>
                </div>
            </div>
          {/* <Title props={aboutUsProp} /> */}
          {/* <AboutUsData /> */}
        </div>
      </div>
    );
  };
  
  export default Projects;
  